import { jsx as _jsx } from "react/jsx-runtime";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import React from "react";
import styled from "styled-components";
export var HeroModule = function() {
    var image = useResponsiveValue({
        mobileAndAbove: {
            src: "https://cdn.faire.com/fastly/b6c3b48fc52944554f7ca53279f9b1b8e98f73bd3e597616debe0ab558a1749e.png",
            height: 429
        },
        tabletAndAbove: {
            src: "https://cdn.faire.com/fastly/d6212773419c649c401499a161fe059bd1071f35f950102f301c97e2bba57bec.png",
            height: 429
        },
        desktopAndAbove: {
            src: "https://cdn.faire.com/fastly/669a4727f9344c3fa89e4c8df4488635497b0be9845aa3e66933825333066b8e.png",
            height: 522
        },
        xLargeAndAbove: {
            src: "https://cdn.faire.com/fastly/bbf5f533b947b984fe0f31b26d6e9bad4bd8accc53c7133c20bcb013c899b63b.png",
            height: 522
        }
    });
    var isSSR = useIsSSR();
    var _optimizeImageUrl;
    return /*#__PURE__*/ _jsx(Image, {
        src: (_optimizeImageUrl = optimizeImageUrl({
            url: image.src
        }, isSSR, {
            height: image.height
        })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
        height: image.height
    });
};
var Image = styled.img.withConfig({
    componentId: "sc-248d96fa-0"
})([
    "display:block;object-fit:cover;width:100%;"
]);
